var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSwiperPregnancyInactiveIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-111.93 -71.215)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.93 71.215)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 17,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.5,112.45A14.029,14.029,0,1,1,230.53,98.421,14.045,14.045,0,0,1,216.5,112.45Zm0-27a12.971,12.971,0,1,0,12.971,12.971A12.986,12.986,0,0,0,216.5,85.45Z",
    transform: "translate(-199.502 -81.421)",
    fill: "#635c7c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-26.393 19.4)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(146.322 61.554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M164.367,76.446h0a2,2,0,0,0-2.472-.718l-.779.346s-.208-2.371-1.884-2.429h-.466",
    transform: "translate(-151.141 -68.044)",
    fill: "none",
    stroke: "#635c7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.151,79.646l.624,1.363a1.5,1.5,0,0,0,1.987.74h0l.682-.312",
    transform: "translate(-150.903 -70.368)",
    fill: "none",
    stroke: "#635c7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.08,78.7l1.215-2.2a4.55,4.55,0,0,0,.477-3.251c-.025-.1-.053-.2-.086-.293a3.108,3.108,0,0,0-1.618-1.733,3.922,3.922,0,0,0-3.721.879h0a.75.75,0,0,0-.994-.37l-.157.072a1.5,1.5,0,0,0-.768,1.922c.417,1.068,1.127,2.376,2.116,2.41",
    transform: "translate(-146.322 -67.031)",
    fill: "none",
    stroke: "#635c7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.79,68.238a4.435,4.435,0,1,1,6.984,4.287,1.368,1.368,0,0,0-.581,1.024c-.017.319-.032.59-.037.62a7.055,7.055,0,0,1-1.14,2.68,10.226,10.226,0,0,1-6.493,4.164,7.1,7.1,0,0,1-4.229-.358,4.317,4.317,0,0,1-2.551-3.041A5.582,5.582,0,0,1,150,73.476l1.2-1.485",
    transform: "translate(-147.242 -64.504)",
    fill: "none",
    stroke: "#635c7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("path", {
    d: "M151.49,57.834c3.268,0,3.736,1.188,3.736,3.858s-1.4,4.272,0,6.943",
    transform: "translate(-1.279 -1.48)",
    fill: "none",
    stroke: "#635c7c",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwiperPregnancyInactiveIcon);
export default __webpack_public_path__ + "static/media/swiper_pregnancy_inactive_icon.2a993ee8.svg";
export { ForwardRef as ReactComponent };